export const SEARCH = 'start-search';
export const DIRECTORY = 'directory';
export const KEYBOARD_SHORTCUTS = 'keyboard-shortcuts';
export const SEARCH_MESSAGES = 'search-messages';
export const SWITCH_TEAM = 'switch-team';



// WEBPACK FOOTER //
// ./src/utils/KeyboardShortcuts/eventIds.js